export const FETCH_END_BOOKS = "setBooks";
export const FETCH_START_BOOKS = "setLoadingBooks";

export const FETCH_END_ARTICLES = "setArticles";
export const FETCH_START_ARTICLES = "setLoadingArticles";

export const FETCH_END_BLOG = "setArticles";
export const FETCH_START_BLOG = "setLoadingArticles";

export const FETCH_END_AUTHORS = "setAuthors";
export const FETCH_START_AUTHORS = "setLoadingAuthors";

export const FETCH_END_MANUFACTURERS = "setManufacturers";
export const FETCH_START_MANUFACTURERS = "setLoadingManufacturers";

export const FETCH_END_MODELS = "setModels";
export const FETCH_START_MODELS = "setLoadingModels";

export const FETCH_END_VARIANTS = "setVariants";
export const FETCH_START_VARIANTS = "setLoadingVariants";

export const FETCH_END_VIDEOS = "setArticles";
export const FETCH_START_VIDEOS = "setLoadingArticles";

export const FETCH_END_PRODUCTS = "setProducts";
export const FETCH_START_PRODUCTS = "setLoadingProducts";

export const PURGE_AUTH = "logOut";

export const SET_AUTH = "setUser";
export const SET_AUTHOR = "setAuthor";

export const SET_ARTICLE = "setArticle";
export const APPEND_ARTICLES = "appendArticles";
export const SET_ARTICLES_COUNT = "setArticlesCount";

export const APPEND_BLOG = "appendBlog";
export const SET_BLOG_COUNT = "setBlogCount";

export const SET_BOOK = "setBook";
export const APPEND_BOOKS = "appendBooks";
export const SET_BOOKS_COUNT = "setBooksCount";

export const SET_CONTENT = "setContent";
export const SET_ERROR = "setError";
export const SET_MANUFACTURER = "setManufacturer";
export const SET_MODEL = "setModel";
export const SET_VARIANT = "setVariant";

export const APPEND_VIDEOS = "appendVideos";
export const SET_VIDEOS_COUNT = "setVideosCount";

export const SET_PRODUCT = "setProduct";

export const SET_SEARCH_TEXT = "setSearchText";

export const RESET_STATE = "resetModuleState";
